import { API_CONFIG, buildUrl } from '../config/apiConfig'
import type { 
  Prescription, 
  CreatePrescriptionRequest, 
  UpdatePrescriptionRequest,
  PrescriptionsListResponse,
  PrescriptionsQueryParams 
} from '../types/api'

export const prescriptionsApi = {
  // GET /prescriptions?clinic_id=xxx&patient_id=xxx&status=pending
  async getPrescriptions(params?: PrescriptionsQueryParams): Promise<PrescriptionsListResponse> {
    const url = buildUrl(API_CONFIG.PRESCRIPTIONS.LIST, params)
    const response = await fetch(url)
    
    if (!response.ok) {
      throw new Error(`Failed to fetch prescriptions: ${response.statusText}`)
    }
    
    return response.json()
  },

  // GET /prescriptions/:prescriptionId
  async getPrescription(prescriptionId: string): Promise<Prescription> {
    const response = await fetch(API_CONFIG.PRESCRIPTIONS.DETAIL(prescriptionId))
    
    if (!response.ok) {
      throw new Error(`Failed to fetch prescription: ${response.statusText}`)
    }
    
    return response.json()
  },

  // POST /prescriptions
  async createPrescription(prescriptionData: CreatePrescriptionRequest): Promise<Prescription> {
    const response = await fetch(API_CONFIG.PRESCRIPTIONS.CREATE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(prescriptionData),
    })
    
    if (!response.ok) {
      throw new Error(`Failed to create prescription: ${response.statusText}`)
    }
    
    return response.json()
  },

  // PUT /prescriptions/:prescriptionId
  async updatePrescription(prescriptionId: string, prescriptionData: UpdatePrescriptionRequest): Promise<Prescription> {
    const response = await fetch(API_CONFIG.PRESCRIPTIONS.UPDATE(prescriptionId), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(prescriptionData),
    })
    
    if (!response.ok) {
      throw new Error(`Failed to update prescription: ${response.statusText}`)
    }
    
    return response.json()
  },
}